<script>
import { createEventDispatcher, onMount } from "svelte";
import { getData } from "./util/getData";

const dispatch = createEventDispatcher();

export let groupId;
export let requestId;

let lament;
$: lamentParagraphs = lament && lament.lament ? lament.lament.split('\n') : [];
let isClaimed = false;

onMount(async () => {
    lament = await getData('random-lament', { code: groupId, requestId });
});

function onClaimLament() {
    isClaimed = true;
    dispatch('claim', lament.id);
}
</script>

<article class="splash card">
    {#if isClaimed}
        <h2>Lament</h2>
        {#each lamentParagraphs as para}
        <p>{para}</p>
        {/each}
    {:else}
        <h2>Receive</h2>
        <p>Do you wish to receive a lament?</p>
        <p><button class="pure-button button-primary button-round" on:click={onClaimLament} >Receive lament</button></p>
    {/if}
</article>


